import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {

	const { token } = useSelector(state => state.auth)
	const urlParams = new URLSearchParams(window.location.search);
	const redirect = urlParams.get('redirect');
	const targetRoute = redirect && redirect !== '/' ? redirect : AUTHENTICATED_ENTRY;
  
	return token ? <Navigate to={targetRoute} /> : <Outlet/>
}

export default PublicRoute